define('glu/grid/row/messageRow',['require','../../itemView','hbs!./messageRow.hbs'],function(require) {
    'use strict';

    var ItemView = require('../../itemView'),
        tmpl = require('hbs!./messageRow.hbs');

    return ItemView.extend({
        tagName: 'tr',
        template: tmpl,

        templateHelpers: function() {
            return {
                ifPlural: function(length) {
                    return (length > 1) ? 's' : null;
                },
                colspan: this.options.colspan
            };
        }
    });
});

